let __prevAuthHeader = null;

export async function signInToHl(settings) {
    if (!settings?.hlUrl) return false;
    if (!settings?.portalIdentifier) return false;

    const auth = settings?.headers?.Authorization?.trim();

    if (!auth) return false;

    if (__prevAuthHeader && __prevAuthHeader === auth) {
        return true;
    }

    try {
        const url = new URL(`${settings.hlUrl}/api/Dashboard/SignIn`);

        url.searchParams.append('portalidentifier', settings.portalIdentifier);

        const response = await fetch(url.toString(), {
            headers: settings.headers,
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
        }

        __prevAuthHeader = auth;
        return true;
    } catch (err) {
        console.error('HL sign-in API call failed:', err);
        return false;
    }
}
